import { useQuery } from 'react-query';
import request from '../../../../../helpers/request';

export const shutdownHistoryKey = (shutdownId) => [
  'shutdownHistory',
  shutdownId,
];

const shutdownHistoryQuery = async ({ queryKey }) => {
  const [_, shutdownId] = queryKey;

  return await request.get(
    `/Alert/history/${shutdownId}`,
    {},
    `При загрузке истории произошла ошибка`
  );
};

export const useShutdownHistory = (shutdownId, options) =>
  useQuery(shutdownHistoryKey(shutdownId), shutdownHistoryQuery, options);
